<script setup lang="ts">
import type { CmsElementCardsAndCategories } from "~/composables/useCustom";
import { getSanitizeUrl } from '~/components/utilities'

const props = defineProps<{
  content: CmsElementCardsAndCategories;
  style: any,
  class: any
}>();

const config = props.content?.config ?? {};
const heading = config.heading;
const subHeading = config.subHeading;
const cards = config.cards;
const categories = config.categories;

</script>

<template>
  <div class="section section-services" :style="props.style" :class="props.class">
    <div class="container">
      <div class="section__image">
        <NuxtImg format="webp" loading="lazy" src="/assets/images/temp/image-4.jpg" alt="" width="1440" height="540"></NuxtImg>
      </div><!-- /.section__image -->

      <header class="section__head">
        <h1>{{ heading?.value }}</h1>
      </header><!-- /.section__head -->

      <div class="section__body">
        <div class="row">
          <div class="col-sm-6 col-md-3" v-for="(card, index) in (cards?.value ?? [])" :key="index">
            <div class="card card--primary">
              <div class="card__inner">
                <NuxtLink :to="getSanitizeUrl(card.cardLink?.url)" :target="card.cardLink?.target"></NuxtLink>

                <div class="card__image">
                  <NuxtImg format="webp" loading="lazy" :src="card.cardImage?.url" alt="" width="227" height="227"></NuxtImg>
                </div><!-- /.card__image -->

                <div class="card__content">
                  <NuxtLink class="btn btn-default btn-danger" :to="card.cardLink?.url" :target="card.cardLink?.target"><span>{{ card.cardText }}</span></NuxtLink>
                </div><!-- /.card__content -->
              </div><!-- /.card__inner -->
            </div><!-- /.card card-/-primary -->
          </div><!-- /.col-md-3 -->
        </div><!-- /.row -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </div>
  <section class="section section-main section-links">
    <div class="container">
      <header class="section__head">
        <h2>{{ subHeading?.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <ul class="list-links">
          <li v-for="(category, index) in (categories?.value ?? [])" :key="index">
            <NuxtLink :to="getSanitizeUrl(category.link?.url)" :target="category.link?.target">{{ category.name }}</NuxtLink>
          </li>
        </ul><!-- /.list-links -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>